import { useCallback } from 'react';
import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { CharityAPIResponse } from '@Types';
import { CHARITY_NUMBER_REGEX } from '@Helpers/fieldValidation';

export const useGetCharityDetails = () => {
  const [fetch, requestState] = useRequest<CharityAPIResponse>();

  const getCharityDetails = useCallback(
    (charityNumber: string) => {
      // Validate charity number format before making API call.
      if (!CHARITY_NUMBER_REGEX.test(charityNumber)) {
        // Don't make the API call if charity number is invalid.
        return Promise.reject(new Error('Invalid charity number format'));
      }

      // Make the API call to fetch charity details.
      // - Success (200): response.data contains CharityAPIResponse with populated charity data.
      // - HTTP Errors (400/404/500): Django returns structured error responses with non-200 status codes.
      //   Axios treats these as errors, so useRequest sets response.isError=true and response.error
      //   contains the Django response body: {data: null, error: "specific error message"}.
      // - Network Errors: response.isError=true, response.error=undefined (no response body).
      return fetch(API.paths.charity_data(charityNumber), 'get');
    },
    [fetch],
  );

  return [getCharityDetails, requestState] as const;
};
